import { Link, useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import axios from "axios"
import { FaUserAlt, FaEye, FaEyeSlash } from 'react-icons/fa';
import { getMessaging, getToken } from "firebase/messaging";
import premierLeagueLion from './assets/Premier-league-logos/pl-main-logo.png';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const saveFcmToken = async (userId) => {
        try {
            const messagingInstance = getMessaging();
            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                console.log("Notification permission denied");
                return;
            }
            const currentToken = await getToken(messagingInstance, {
                vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
            });
            if (currentToken) {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/save-fcm-token`,
                    { userId, fcmToken: currentToken },
                    { withCredentials: true }
                );
            }
        } catch (err) {
            console.log("FCM Token error:", err);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        const API_URL = process.env.REACT_APP_API_URL;
        try {
            const res = await axios.post(`${API_URL}/login`, {
                email,
                password
            }, { withCredentials: true })

            if (res.data.status === "exist") {
                localStorage.setItem("username", res.data.username);
                localStorage.setItem("fplId", res.data.fplId);
                localStorage.setItem("email", res.data.email);
                localStorage.setItem("token", res.data.accessToken);
                localStorage.setItem("userId", res.data._id);
                localStorage.removeItem("isGuest");

                saveFcmToken(res.data._id);

                const userEmail = res.data.email?.toLowerCase();
                if (userEmail === "mutumasteve29@gmail.com") {
                    navigate("/admin-gate");
                } else {
                    navigate("/payment");
                }
            } else {
                setError('Invalid email or password. Please try again.');
                setLoading(false);
            }
        } catch (error) {
            setError('Server error. Please try again later.');
            console.error("Login error", error);
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#2d006b] flex flex-col justify-center items-center font-sans" >
            {loading && (
                <div className="fixed inset-0 bg-white/60 backdrop-blur-sm flex justify-center items-center z-[9999]">
                    <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-400 rounded-full animate-spin"></div>
                </div>
            )}

            <div className={`flex flex-col items-center gap-3 ${loading ? 'blur-sm pointer-events-none select-none' : ''}`}>
                <div className="flex flex-row items-center gap-3">
                    <img src={premierLeagueLion} alt="Premier League Logo" className="w-16 h-auto" />
                    <h1 className="text-white text-4xl font-bold leading-tight">Premier League</h1>
                </div>

                <div className="bg-white rounded-2xl flex flex-col items-center p-7 w-80 ">
                    <h2 className="text-xl font-semibold text-gray-800 text-center ">Login</h2>

                    <form onSubmit={handleLogin} className="flex flex-col w-full gap-3 mt-3">
                        <div className="relative">
                            <input
                                type="email"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email address"
                                required
                                className="w-full bg-gray-100 border border-gray-200 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#2d006b]"
                            />
                        </div>

                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                required
                                className="w-full bg-gray-100 border border-gray-200 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#2d006b]"

                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        {error && <p className="text-red-500 text-xs text-center font-medium">{error}</p>}

                        <button type="submit" className="bg-[#2d006b] text-white rounded-xl py-3 w-full font-semibold mt-2 hover:bg-[#3d0090] transition-colors">
                            Login
                        </button>

                        <Link to="/forgot-password" className="no-underline text-[#2d006b] text-sm font-semibold text-center mt-1">
                            Forgot password?
                        </Link>

                        <p className="text-gray-500 text-sm text-center font-normal">
                            Don't have an account? <Link to="/register" className="no-underline text-[#2d006b] font-semibold">Register</Link>
                        </p>
                    </form>
                </div>
            </div>

            <button
                onClick={() => { localStorage.setItem("isGuest", "true"); navigate('/payment') }}
                className="mt-4 md:fixed md:bottom-5 md:left-5 flex items-center gap-2 border-2 border-white text-white text-sm rounded-full px-4 py-2 bg-transparent hover:bg-[#0a5581] transition-colors"

            >
                <FaUserAlt />
                Enter as Guest
            </button>
        </div>
    );
}

export default Login